import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.greys.lightest};
  border-radius: ${({ theme }) => theme.borders.radius.strong};
  box-shadow: ${({ theme }) => theme.shadows.short};
`;
